import { render, staticRenderFns } from "./dzHome.vue?vue&type=template&id=6e00b47c"
import script from "./dzHome.vue?vue&type=script&lang=js"
export * from "./dzHome.vue?vue&type=script&lang=js"
import style0 from "./dzHome.vue?vue&type=style&index=0&id=6e00b47c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports